module.exports = __webpack_public_path__ + "static/media/023-cocos-island.f0bc28bd.svg";